import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent(
    'Shadowform',
    'spell_shadow_shadowform',
    ['Assume shadowform, increasing Shadow damage by 15% and reducing physical damage taken by 15%. The priest can not cast Holy spells in this form.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    '40% of base mana',
    null,
    'Instant',
    '1.5 sec cooldown'
  ),
  null,
  null,
]

export default tier7
